var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-back",attrs:{"height":_vm.height,"width":_vm.width,"color":_vm.color},on:{"click":_vm.goBack}},[(_vm.icon)?_c('SIcon',{attrs:{"name":_vm.icon}}):_c('v-icon',{staticStyle:{"color":"#6b7786"}},[_vm._v("mdi-arrow-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }